import { baseFetch } from './base.js';


const basePath = 'saleroom';

export const getSalerooms = (sessionId) => {
  return baseFetch(`${basePath}/${sessionId}`, 'GET');
}